import React from "react";
import { NavLink } from "react-router-dom";
import logo from "../../assets/pc/logo.svg";

const Menu = () => {
  function topFunction() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }
  return (
    <div className="menu__container">
      <div className="menu__container__content">
        <div className="menu__container__content__logo u-ml">
          <NavLink to="/" onClick={topFunction}>
            <img src={logo} alt="" />
          </NavLink>
        </div>
        <ul className="menu__container__content__links u-ttu">
          <NavLink to="/" onClick={topFunction}>
            {({ isActive }) => (
              <>
                <span>
                  <svg
                    className={isActive ? "active" : "svg"}
                    width="22"
                    height="22"
                    viewBox="0 0 22 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    id="svg"
                  >
                    <path
                      d="M13.5607 4.43209L2.52083 15.4889M6.15496 15.741V19.3747M15.845 15.741V19.3747M17.6623 19.3747H4.33767C3.85581 19.3747 3.39369 19.1833 3.05297 18.8425C2.71225 18.5018 2.52083 18.0397 2.52083 17.5578V11.0976C2.5208 10.8588 2.56787 10.6223 2.65933 10.4017C2.7508 10.1811 2.88487 9.98074 3.05387 9.81201L9.71575 3.15701C10.0564 2.81644 10.5183 2.62512 11 2.62512C11.4817 2.62512 11.9436 2.81644 12.2842 3.15701L18.9461 9.81201C19.1151 9.98074 19.2492 10.1811 19.3407 10.4017C19.4321 10.6223 19.4792 10.8588 19.4792 11.0976V17.5578C19.4792 18.0397 19.2877 18.5018 18.947 18.8425C18.6063 19.1833 18.1442 19.3747 17.6623 19.3747V19.3747ZM6.15496 15.741H15.8446V11.8507L11 7.01067L6.15496 11.8507V15.741Z"
                      stroke-width="1.46"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
                <span className={isActive ? "active" : undefined}>Home</span>
              </>
            )}
          </NavLink>
          <NavLink to="/about" onClick={topFunction}>
            {({ isActive }) => (
              <>
                <span>
                  <svg
                    width="22"
                    height="22"
                    viewBox="0 0 22 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className={isActive ? "active" : "svg"}
                  >
                    <path
                      d="M4.63099 17.5276C4.64337 17.5157 6.17054 16.077 6.17054 14.2881C6.17054 13.0552 5.467 11.8332 4.7222 10.5394C3.87566 9.06904 3.0007 7.54875 3.0007 5.76812C2.97565 5.29572 3.0475 4.82318 3.21184 4.37958C3.37618 3.93597 3.62954 3.53068 3.95633 3.18862C4.02508 3.10704 4.09612 3.02454 4.16487 2.93333C4.33201 2.71295 4.57985 2.56799 4.85388 2.53034C5.1279 2.49269 5.40565 2.56544 5.62604 2.73258C5.84642 2.89972 5.99138 3.14757 6.02903 3.42159C6.06668 3.69561 5.99393 3.97336 5.82679 4.19375C5.7342 4.31521 5.64024 4.4275 5.5472 4.53658C5.38065 4.69255 5.25239 4.88489 5.17241 5.09859C5.09243 5.3123 5.0629 5.54159 5.08612 5.76858C5.08612 6.99187 5.78737 8.20967 6.52987 9.49942C7.37779 10.9739 8.25595 12.4983 8.25595 14.2881C8.24657 15.1495 8.04818 15.9983 7.67479 16.7745"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M6.01333 3.33484C6.017 3.35134 6.50833 5.39092 8.06208 6.27871C9.13229 6.89013 10.5417 6.88463 12.0354 6.88096C13.7298 6.87317 15.4857 6.86951 17.0312 7.75271C17.4539 7.96527 17.8287 8.26209 18.1324 8.62491C18.4361 8.98774 18.6623 9.40888 18.7972 9.86242C18.8338 9.9628 18.8705 10.065 18.9154 10.1695C18.9707 10.2957 19.0005 10.4316 19.003 10.5694C19.0054 10.7072 18.9806 10.8441 18.9298 10.9722C18.879 11.1003 18.8034 11.2171 18.7072 11.3158C18.611 11.4145 18.4963 11.4932 18.3695 11.5472C18.2428 11.6013 18.1065 11.6297 17.9687 11.6308C17.8309 11.6319 17.6943 11.6057 17.5667 11.5536C17.4391 11.5016 17.3231 11.4248 17.2253 11.3276C17.1276 11.2305 17.0501 11.1149 16.9973 10.9876C16.9373 10.8469 16.8873 10.7099 16.8378 10.5751C16.785 10.3531 16.6816 10.1463 16.5357 9.97088C16.3898 9.79541 16.2054 9.65603 15.9968 9.56359C14.9353 8.95676 13.53 8.96042 12.0418 8.96638C10.3395 8.96959 8.58138 8.97738 7.02763 8.08959C6.27146 7.64625 5.62357 7.04001 5.13104 6.31492"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M17.594 11.6036C17.5775 11.5986 15.5668 10.9995 14.02 11.8979C12.9534 12.5166 12.2499 13.7385 11.5046 15.0324C10.6581 16.5018 9.78221 18.0221 8.24221 18.9154C7.68558 19.2694 7.04271 19.4644 6.38321 19.4792C6.09721 19.4739 5.8123 19.4423 5.53209 19.3847C5.42414 19.3641 5.31562 19.3465 5.20667 19.332C5.06873 19.3178 4.93501 19.2762 4.81334 19.2097C4.69167 19.1432 4.58449 19.053 4.49808 18.9446C4.41166 18.8361 4.34775 18.7115 4.31007 18.5781C4.2724 18.4446 4.26173 18.305 4.27868 18.1674C4.29562 18.0297 4.33986 17.8969 4.40878 17.7765C4.47771 17.6562 4.56994 17.5508 4.68008 17.4666C4.79023 17.3824 4.91607 17.3209 5.05025 17.2859C5.18442 17.2509 5.32424 17.243 5.4615 17.2627C5.61367 17.281 5.75759 17.3067 5.89875 17.3314C6.11723 17.3972 6.34795 17.4117 6.57294 17.3737C6.79793 17.3357 7.0111 17.2462 7.19584 17.1123C8.25367 16.4982 8.95492 15.2804 9.69788 13.9911C10.5472 12.5175 11.4249 10.9931 12.9731 10.0943C13.7548 9.65279 14.6267 9.39481 15.5228 9.3399"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
                <span className={isActive ? "active" : undefined}>About</span>
              </>
            )}
          </NavLink>
          <NavLink to="/collection" onClick={topFunction}>
            {({ isActive }) => (
              <>
                <span>
                  <svg
                    width="22"
                    height="22"
                    viewBox="0 0 22 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className={isActive ? "active" : "svg"}
                  >
                    <g clip-path="url(#clip0_31_211)">
                      <path
                        d="M2.52083 0.916687L1.4465 13.3504L2.8985 13.0098L1.33696 14.6186L0.916664 19.4792L14.5026 20.6534L14.8798 17.6115L15.8602 20.7708L19.4792 21.0834L20.5333 8.88298L18.843 6.95477L20.6855 7.12252L21.0833 2.52085L8.39483 1.42406L7.68991 3.1946L7.14771 1.31635L2.52083 0.916687Z"
                        stroke-width="1.46"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M5.04992 6.82552C5.55618 6.82552 5.96659 6.41512 5.96659 5.90885C5.96659 5.40259 5.55618 4.99219 5.04992 4.99219C4.54366 4.99219 4.13326 5.40259 4.13326 5.90885C4.13326 6.41512 4.54366 6.82552 5.04992 6.82552Z"
                        stroke-width="1.46"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M4.90463 10.9381C5.41089 10.9381 5.82129 10.5277 5.82129 10.0215C5.82129 9.5152 5.41089 9.1048 4.90463 9.1048C4.39837 9.1048 3.98796 9.5152 3.98796 10.0215C3.98796 10.5277 4.39837 10.9381 4.90463 10.9381Z"
                        stroke-width="1.46"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M4.83404 15.0544C5.3403 15.0544 5.75071 14.644 5.75071 14.1377C5.75071 13.6315 5.3403 13.2211 4.83404 13.2211C4.32778 13.2211 3.91737 13.6315 3.91737 14.1377C3.91737 14.644 4.32778 15.0544 4.83404 15.0544Z"
                        stroke-width="1.46"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M7.93284 6.77417L18.1725 7.83613M7.43234 10.5398L17.8567 11.4987M7.08997 14.3532L17.4336 14.8161"
                        stroke-width="1.46"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_31_211">
                        <rect width="22" height="22" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </span>
                <span className={isActive ? "active" : undefined}>
                  Collection
                </span>
              </>
            )}
          </NavLink>
          <NavLink to="/contact" onClick={topFunction}>
            {({ isActive }) => (
              <>
                <span>
                  <svg
                    width="22"
                    height="22"
                    viewBox="0 0 22 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className={isActive ? "active" : "svg"}
                  >
                    <path
                      d="M11 5.83002C11.4079 5.83002 11.8067 5.95098 12.1459 6.17761C12.485 6.40424 12.7494 6.72636 12.9055 7.10323C13.0616 7.48011 13.1025 7.8948 13.0229 8.29489C12.9433 8.69498 12.7469 9.06248 12.4584 9.35092C12.17 9.63937 11.8025 9.8358 11.4024 9.91539C11.0023 9.99497 10.5876 9.95412 10.2107 9.79802C9.83384 9.64191 9.51172 9.37756 9.28509 9.03838C9.05846 8.6992 8.9375 8.30044 8.9375 7.89252C8.9375 7.34551 9.1548 6.8209 9.54159 6.43411C9.92839 6.04732 10.453 5.83002 11 5.83002V5.83002ZM11 10.9588C13.2917 10.9588 15.125 11.6004 15.125 12.3658V14.3367H6.875V12.375C6.875 11.6004 8.70833 10.9588 11 10.9588Z"
                      stroke-width="1.46"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M10.175 2.2275L3.06625 5.15625V12.375C3.06625 16.2433 11 19.9375 11 19.9375C11 19.9375 18.9338 16.2433 18.9338 12.375V5.15625L11.825 2.2275C11.5636 2.11858 11.2832 2.0625 11 2.0625C10.7168 2.0625 10.4364 2.11858 10.175 2.2275V2.2275Z"
                      stroke-width="1.46"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
                <span className={isActive ? "active" : undefined}>Contact</span>
              </>
            )}
          </NavLink>
        </ul>
      </div>
    </div>
  );
};

export default Menu;
